import * as React from 'react'
import styled from 'styled-components'
import { zIndexSystem } from '@/styles/theme'
import { Toast, ToastProps } from '@musinsa/mwms-ds'
import { DEVICES } from '@/styles/devices'

export function ToastListBox({ list, destroy }: { list: Omit<ToastProps, 'open'>[]; destroy: (id: string) => void }) {
  return (
    <ToastListBoxWrapper>
      {!list.length
        ? null
        : list.map((toast) => (
            <Toast
              {...toast}
              id={toast.id}
              content={toast.content}
              open
              onClose={() => {
                if (toast.onClose) toast.onClose()
                destroy(toast.id)
              }}
              key={`toast-list-box-${toast.id}`}
            />
          ))}
    </ToastListBoxWrapper>
  )
}

const ToastListBoxWrapper = styled.div`
  position: fixed;
  z-index: ${zIndexSystem.modal + 2};

  ${DEVICES.pc} {
    top: 18px;
    right: 32px;
    display: inline-flex;
    flex-direction: column;
    gap: 12px;
  }

  ${DEVICES.mobile} {
    left: 8px;
    right: 8px;
    bottom: 40px;
  }
`

export default Toast
